import React from 'react';
import { Switch, Route } from 'react-router-dom';

import HomePage from '../pages/HomePage';
import EmentList from '../pages/EmentList';

const Routes: React.FC = () => (
  <Switch>
    <Route path="/" exact component={HomePage} />
    <Route path="/ement/:ement" component={EmentList} />
  </Switch>
);

export default Routes;
